import {
  AnimatePresence,
  LayoutGroup,
  motion,
  useMotionValueEvent,
  useScroll,
} from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import React, { useState } from 'react'
import { ReactComponent as ChevronLeft } from './../../images/icons/chevron_left.svg'
import { isEmpty } from 'lodash'
import { Pill } from '@demandlocal/components'
import TabMenu from '../TabMenu/TabMenu'

type Props = {
  title?: string
  infoPill?: {
    type: 'gray' | 'info' | 'warning' | 'error' | 'success' | 'info-purple' | 'rainbow'
    content: string
  }
  backRoute?: string
  rightSlot?: (props: { hidden: boolean }) => React.ReactElement
  icon?: JSX.Element
  tabMenu?: Array<{ to: string; name: string; visible?: boolean }>
}

const PageHeader = ({
  title,
  backRoute,
  rightSlot,
  icon,
  infoPill,
  tabMenu,
}: Props): JSX.Element => {
  const { scrollY } = useScroll()
  const navigate = useNavigate()
  const [hidden, setHidden] = useState(false)

  useMotionValueEvent(scrollY, 'change', (latestValue) => {
    if (latestValue > 15) setHidden(true)
    else setHidden(false)
  })
  return (
    <AnimatePresence>
      <LayoutGroup id={`${title}-page-header`}>
        <motion.div
          className={`flex justify-between sticky top-0 z-10 bg-white shadow-lg`}>
          <div className={'flex flex-1 max-w-[1920px] mx-auto flex-col'}>
            <div className="flex flex-1 px-10 py-3">
              <div className={`flex flex-row justify-between items-center flex-1`}>
                <div className={'flex items-center gap-4 pr-2'}>
                  {backRoute && (
                    <ChevronLeft
                      // @ts-ignore
                      className={'fill-primary-xiketic/50 cursor-pointer print:hidden'}
                      onClick={() => navigate(backRoute)}
                    />
                  )}
                  {icon && <div>{icon}</div>}
                  <h1
                    className={
                      'text-xl font-Spartan font-bold line-clamp-1 pb-1 text-primary-xiketic'
                    }>
                    {title}
                  </h1>
                  {!isEmpty(infoPill) && (
                    <Pill type={infoPill.type}>{infoPill.content}</Pill>
                  )}
                </div>
              </div>
              <div className={`flex flex-row gap-3 justify-end items-center`}>
                <motion.div layout={'preserve-aspect'}>
                  {rightSlot
                    ? typeof rightSlot === 'function'
                      ? React.cloneElement(rightSlot({ hidden }))
                      : rightSlot
                    : null}
                </motion.div>
              </div>
            </div>
            {tabMenu && (
              <>
                <div className="px-10 pt-3">
                  <TabMenu condensed={false} options={tabMenu} />
                </div>
              </>
            )}
          </div>
        </motion.div>
      </LayoutGroup>
    </AnimatePresence>
  )
}

export default PageHeader
